// extracted by mini-css-extract-plugin
export default {"root":"ConfirmDialog-module__root___1DQsD"};